import { getAvailableLevels } from "@/constants/levels";
import { DAYS_FOR_NOTIFICATION } from "@/constants";
import { Network } from "@/interfaces/network";

import { getDaysRemaining } from "./date";

export const isActionAllowed = (
  network: Network,
  userLevel: number,
  currentScore: number,
  newScore: number | null,
  expirationDate: number | null,
) => {
  const availableLevels = getAvailableLevels(network);
  if (userLevel > 1 && userLevel < availableLevels.length && availableLevels[userLevel]) return true;

  const dateNow = Date.now();

  if (expirationDate) {
    if (dateNow > expirationDate) return true;
    const daysRemaining = getDaysRemaining(expirationDate);
    if (daysRemaining < DAYS_FOR_NOTIFICATION) return true;
  }
  if (newScore && newScore > currentScore) return true;
  return false;
};
